import axios from 'axios'
// import { createPinia } from 'pinia';
// import { useAuthStore } from "@/state/pinia";

// const pinia = createPinia();
// const useAuth = useAuthStore(pinia);
// console.log(useAuth)
import { authHeader } from './../helpers/authservice/auth-header';

let _authAxiosBackend = null;
let _axiosBackend = null;
let _axiosBackendMubinApi = null;

export function initAxiosBackend(config = {}) {
    _authAxiosBackend = axios.create({
        baseURL: config.baseURL,
        headers: {
            'accept': 'application/json',
        }
    })

    _axiosBackendMubinApi = axios.create({
        baseURL: config.baseURLMubinApi,
        headers: {
            'accept': 'application/json',
        }
    })
     

    _axiosBackend = _authAxiosBackend
}

export function  getAuthAxiosBackend() {
    // console.log(authHeader())
    _authAxiosBackend.defaults.headers.common['Authorization'] = authHeader() // useAuth.getToken
    return _authAxiosBackend
}

export function  getAxiosBackend() {
    return _axiosBackend
}

export function  getAxiosBackendMubinApi() {
    return _axiosBackendMubinApi
}